export default "__VITE_PUBLIC_ASSET__4c0ed7dd__"